module.exports = __webpack_public_path__ + "img/img-event-m-tab-02.2b5531cc.png";